import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { UserService } from '@consumers/services';

const avatarColours = [
  '#EA1212',
  '#FF7E28',
  '#FFAC1C',
  '#6DD400',
  '#44D7B6',
  '#32C5FF',
  '#0091FF',
  '#6236FF',
  '#B620E0',
  '#F71762',
  '#D8D8D8',
  '#D8C6A7',
  '#B6C9A2',
  '#B0A496',
  '#7E7B8F',
];

const ProfileAvatar = ({
  className = '',
  userData,
  ref = null,
  onClick = () => {},
}) => {
  const getProfileImage = React.useCallback(async () => {
    const { data } = await UserService.getPersonDetails(userData.rcuser_uid);
    setProfileImage((data && data.avatar) || null);
  }, [userData.rcuser_uid]);
  const { profileImageUri, fullName, name } = userData;
  const [profileImage, setProfileImage] = React.useState(
    !profileImageUri ? null : false
  );
  let firstName = '',
    lastName = '';

  if (fullName || name) {
    const userName = fullName || name;
    const nameSplit = userName.split(' ').filter(name => !!name);
    firstName = nameSplit[0].toUpperCase();
    lastName =
      nameSplit.length > 1 ? nameSplit[nameSplit.length - 1].toUpperCase() : '';
  } else {
    firstName = userData.firstName || '';
    lastName = userData.lastName || '';
  }

  React.useEffect(() => {
    if (profileImageUri) {
      getProfileImage();
    }
  }, [userData.extensionId, getProfileImage, profileImageUri]);

  if (
    !userData ||
    (typeof userData === 'object' && Object.keys(userData).length === 0)
  ) {
    return null;
  }

  const userInitials = firstName.charAt(0) + lastName.charAt(0);
  const charIndex = userInitials.toUpperCase().charCodeAt(0) - 64;

  const avatarProps = {
    src: profileImage,
    style: !profileImage
      ? { backgroundColor: avatarColours[charIndex % avatarColours.length] }
      : null,
    children: !profileImage ? userInitials.toUpperCase() : null,
    ref: ref,
    onClick,
  };

  return profileImage === false ? null : (
    <Avatar className={className} {...avatarProps} />
  );
};

export default ProfileAvatar;
